// Set constants for the search DOM nodes
const desktopSearchToggle = document.querySelector( '#desktop-search-toggle' );
const desktopSearchForm = document.querySelector( '#desktop-search-form' );
const desktopSearchInput = document.querySelector( '#desktop-search-input' );

// Bind event listener for a click to the document
document.addEventListener( 'click', function( event ) { detectClickOnNodeOutsideActiveItem( event.target ) } );

// Bind event listener for an escape keydown to the document
document.addEventListener( 'keydown', function( event ) { if ( event.key === 'Escape' ) { closeOpenDesktopSubmenu(); hideSearchForm(); } } );



// Function to detect a click outside an active menu item or search form
function detectClickOnNodeOutsideActiveItem( clickedNode ) {

  // Try to get an active menu item
  let activeDesktopSubmenuItemLink = document.querySelector( 'a.menu-primary-link[aria-expanded=true]');

  // If there's an active submenu
  if ( activeDesktopSubmenuItemLink ) {

    // If the click is anywhere outside the original menu item
    if ( ! activeDesktopSubmenuItemLink.parentNode.contains( clickedNode ) ) {

      // Close the active submenu
      closeOpenDesktopSubmenu();

    }

  }

  // If this wasn't trigger by the search toggle itself and the search form is active
  if ( ! desktopSearchToggle.contains( clickedNode ) && desktopSearchToggle.getAttribute( 'aria-expanded' ) === 'true' ) {

    // If the click is anywhere outside the original menu item
    if ( ! desktopSearchForm.parentNode.contains( clickedNode ) ) {

      // Close the active submenu
      hideSearchForm();

    }

  }

}



// Function to close an active submenu
function closeOpenDesktopSubmenu( clientX ) {

  // Try to get an active menu item
  let activeDesktopSubmenuItemLink = document.querySelector( 'a.menu-primary-link[aria-expanded=true]')

  // If there is an active submenu
  if ( activeDesktopSubmenuItemLink ) {

    // Set the aria-expanded attribute to false
    // The menu visibility is controlled by this attribute in CSS
    activeDesktopSubmenuItemLink.setAttribute( 'aria-expanded', 'false' );

    // Update the aria label
    activeDesktopSubmenuItemLink.setAttribute( 'aria-label', activeDesktopSubmenuItemLink.getAttribute( 'aria-label' ).replace( 'Deactivate', 'Activate' ) );

    // If it wasn't a keyboard event that triggered this
    if ( clientX !== 0 ) {

      // Blur the menu item to remove focus styles
      activeDesktopSubmenuItemLink.blur();

    }

  }

}



// Function to hide the search form
function hideSearchForm( clientX ) {

  // If the search toggle is active
  if ( desktopSearchToggle.getAttribute( 'aria-expanded' ) === 'true' ) {

    // Hide the search form
    desktopSearchForm.style.display = 'none';

    // Set the aria-expanded attribute to false
    desktopSearchToggle.setAttribute( 'aria-expanded', 'false' );

    // Blur the search input
    desktopSearchInput.blur();

    // If it wasn't a keyboard event that triggered this
    if ( clientX !== 0 ) {

      // Blur the search toggle
      desktopSearchToggle.blur();

    }

  }

}



// Loop through all desktop menu links with children
document.querySelectorAll( 'a.menu-primary-link.has-children' ).forEach( function( desktopMenuItemLink ) {

  // Event listener - when this menu item link is clicked
  desktopMenuItemLink.addEventListener( 'click', function ( event ) {

    // Stop the link being followed and any propagation
    event.preventDefault();
    event.stopPropagation();

    // Store the clicked element as a variable
    let clickedDesktopMenuItemLink = event.target;

    // If the submenu isn't open yet
    if ( clickedDesktopMenuItemLink.getAttribute( 'aria-expanded' ) === 'false' ) {

      // Hide the search form
      hideSearchForm();

      // Close any open submenus
      closeOpenDesktopSubmenu();

      // Set the aria-expanded attribute to true
      // The menu visibility is controlled by this attribute in CSS
      clickedDesktopMenuItemLink.setAttribute( 'aria-expanded', 'true' );

      // Update the aria label
      clickedDesktopMenuItemLink.setAttribute( 'aria-label', clickedDesktopMenuItemLink.getAttribute( 'aria-label' ).replace( 'Activate', 'Deactivate' ) );

      // If it wasn't a keyboard event that triggered this
      if ( event.clientX !== 0 ) {

        // Blur the menu item to remove focus styles
        clickedDesktopMenuItemLink.blur();

      }

    // Otherwise the submenu is already open
    } else {

      // Close the open submenu
      // Send clientX to differentiate between mouse click / key press
      closeOpenDesktopSubmenu( event.clientX );

      // If it wasn't a keyboard event that triggered this
      if ( event.clientX !== 0 ) {

        // Blur the menu item to remove focus styles
        clickedDesktopMenuItemLink.blur();

      }

    }

  } );

} );


// Add an event listener for a click on the desktop search toggle
desktopSearchToggle.addEventListener( 'click', function( event ) {

  // If the search form isn't open yet
  if ( desktopSearchToggle.getAttribute( 'aria-expanded' ) === 'false' ) {

    // Close any open submenus
    closeOpenDesktopSubmenu();

    // Show the search form
    desktopSearchForm.style.display = 'block';

    // Set the aria-expanded attribute to true
    desktopSearchToggle.setAttribute( 'aria-expanded', 'true' );

    // Focus on the search input
    desktopSearchInput.focus();

  // Otherwise the search form is already open
  } else {

    // Hide the search form
    // Send clientX to differentiate between mouse click / key press
    hideSearchForm( event.clientX );

  }

} );
